import React, { useState } from 'react'
import './App.css'
import TaskForm from './components/TaskForm'
import TaskList from './components/TaskList'

function App() {
  const [tasks, setTasks] = useState([
    { id: 1, text: 'Comprar pa', completed: false, dueDate: null },
    { id: 2, text: 'Acabar informe', completed: true, dueDate: new Date().toISOString() },
  ])

  const handleAddTask = text => {
    const task = {
      id: Date.now(),
      text: text,
      completed: false,
      dueDate: null,
    }

    setTasks([...tasks, task])
  }

  const handleToggleComplete = taskId => {
    setTasks(tasks.map(task => (task.id === taskId ? { ...task, completed: !task.completed } : task)))
  }

  const handleDeleteTask = taskId => {
    setTasks(tasks.filter(task => task.id !== taskId))
  }

  const handleUpdateTaskDate = (taskId, newDate) => {
    setTasks(tasks.map(task => (task.id === taskId ? { ...task, dueDate: newDate ? newDate.toISOString() : null } : task)))
  }

  return (
    <div className='app-container'>
      <div className='todo-container'>
        <h1>La Meva Llista de Tasques</h1>

        <TaskForm onAddTask={handleAddTask} />

        <TaskList tasks={tasks} onToggleComplete={handleToggleComplete} onDeleteTask={handleDeleteTask} onUpdateTaskDate={handleUpdateTaskDate} />
      </div>
    </div>
  )
}

export default App
